import React from 'react';
// ----------------------------------------------------------------------------------------------------
import TrainnerProfile from './trainer_profile';
import SequenceProfile from '../../../components/atoms/sequences/sequence_profile';
import LectureProfile from '../../../components/atoms/lectures/lecture_profile';
// ----------------------------------------------------------------------------------------------------
import icoTrainer from '../../../assets/images/ico_trainer.png';
import icoSequence from '../../../assets/images/ico_sequece.png';
import icoLecture from '../../../assets/images/ico_lecture.png';

import icoTrainerW from '../../../assets/images/ico_trainer_white.png';
import icoSequenceW from '../../../assets/images/ico_sequece_white.png';
import icoLectureW from '../../../assets/images/ico_lecture_white.png';
// ----------------------------------------------------------------------------------------------------
const TrainerTabs = (props) => {
  return [
    {
      title: '트레이너',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoTrainerW} />
        ) : (
          <img width={24} height={24} src={icoTrainer} />
        ),
      component: <TrainnerProfile {...props} />,
    },

    {
      title: '시퀀스',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoSequenceW} />
        ) : (
          <img width={24} height={24} src={icoSequence} />
        ),
      component: <SequenceProfile {...props} accountId={props.trainerId} />,
    },

    {
      title: '강의',
      width: '12.7rem',
      height: '3.8rem',
      icon: (checked) =>
        checked ? (
          <img width={24} height={24} src={icoLectureW} />
        ) : (
          <img width={24} height={24} src={icoLecture} />
        ),
      component: <LectureProfile {...props} accountId={props.trainerId} />,
    },
  ];
};
export default TrainerTabs;
